import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {TranslatePipe} from '@brunata-angular/util';
import {
    DeliveryOutcome,
    deliveryOutcomeIconClasses,
    deliveryOutcomeLabelKeys,
} from '../delivery-log.model';

@Component({
    selector: 'app-delivery-outcome-icon',
    standalone: true,
    imports: [TranslatePipe],
    template: `
        @let outcomeLabel = outcomeLabelKeys[outcome()] | translate: 'online' : 'export';
        <i
            [class]="iconClasses[outcome()]"
            [title]="outcomeLabel"
            [attr.aria-label]="outcomeLabel"></i>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryOutcomeIconComponent {
    readonly outcome = input.required<DeliveryOutcome>();

    protected readonly outcomeLabelKeys = deliveryOutcomeLabelKeys;

    protected readonly iconClasses = deliveryOutcomeIconClasses;
}
